import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getSyncHelp } from '../api/syncJobs';

// Hiện trên máy agent dự phòng (vd CSKH Huyền Như) khi có người không lấy được dữ liệu.
export default function SyncHelpPopup() {
  const { me } = useAuth();
  const [help, setHelp] = useState(null);
  const [open, setOpen] = useState(false);

  const isAgent = !!me && (me.role === 'GD' || me.displayRole === 'CV' || me.syncAgent);

  useEffect(() => {
    if (!isAgent) return;
    let alive = true;
    const poll = async () => {
      try {
        const d = await getSyncHelp();
        if (!alive) return;
        if (d.help) {
          const snoozeUntil = Number(localStorage.getItem('ft_help_snooze') || 0);
          if (Date.now() > snoozeUntil) {
            setHelp(d.help);
            setOpen(true);
          }
        } else {
          setHelp(null);
          setOpen(false);
        }
      } catch {
        /* bỏ qua lỗi mạng */
      }
    };
    poll();
    const iv = setInterval(poll, 45000); // hỏi mỗi 45s
    return () => {
      alive = false;
      clearInterval(iv);
    };
  }, [isAgent]);

  if (!isAgent || !open || !help) return null;

  const snooze = () => {
    localStorage.setItem('ft_help_snooze', String(Date.now() + 10 * 60 * 1000)); // ẩn 10 phút
    setOpen(false);
  };
  const openSoc = () => {
    window.open('https://socsonship.com', '_blank', 'noopener');
    snooze();
  };

  return (
    <div className="syncpop-bg">
      <span className="spark" style={{ top: '14%', left: '16%', fontSize: 22 }}>✨</span>
      <span className="spark" style={{ top: '20%', right: '14%', fontSize: 20, animationDelay: '.6s' }}>⭐</span>
      <span className="spark" style={{ bottom: '16%', left: '18%', fontSize: 20, animationDelay: '1.1s' }}>💚</span>
      <span className="spark" style={{ bottom: '20%', right: '16%', fontSize: 22, animationDelay: '.3s' }}>🌟</span>

      <div className="syncpop">
        <span className="badge">📣 NHỜ VẢ KHẨN CẤP</span>
        <div className="cat">🐱</div>
        <div className="ttl">{me.name} xinh gái ơi! 💕</div>
        <div className="msg">
          Liệu bạn có thể giúp <span className="hl">{help.requesterName || 'Mèo Cố Vấn'}</span> đồng bộ dữ liệu không?
          <br />
          Vui lòng mở <span className="hl2">SocSonship.com</span> để nhận ngay 1 cốc <span className="cf">☕</span>{' '}
          <b style={{ color: '#b06a12' }}>Highland</b>!!
        </div>
        <button className="go" onClick={openSoc}>
          ☕ Mở SocSonship.com ngay
        </button>
        <button className="later" onClick={snooze}>
          Để lát nữa…
        </button>
      </div>
    </div>
  );
}
